import axios from "axios";

const wooToken = Buffer.from(
  process.env.GATSBY_GRAVITY_KEY + ":" + process.env.GATSBY_GRAVITY_SECRET
).toString("base64");

const options = {
  headers: {
    Authorization: `Basic ${wooToken}`,
    "Content-Type": "application/json",
  },
};

export const submitForm = async (form) => {
  const dynamicInput = `input_${"1.3"}`.replace(".", "_");
  return await axios.post(
    `https://app.takeshapeadventures.com.au/wp-json/gf/v2/forms/${form.formID}/submissions`,
    {
      ...form.inputs,
    },
    options
  );
};

export const getForm = async (id) => {
  return await axios.get(
    `https://app.takeshapeadventures.com.au/wp-json/gf/v2/forms/${id}`,
    options
  );
};
